import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';

export const initStateUserSendCode = {
  userSendCode: { data: null, loading: false, error: null },
};

export const userSendCode = createAsyncThunk('user/userSendCode', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axios
    .post(
      `${process.env.REACT_APP_SERVER_API}/auth/register/send-code/`,
      { phone_number: data },
      {
        Accept: '*/*',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        Connection: 'keep-alive',
      },
    )
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerUserSendCode = {
  [userSendCode.pending]: (state) => {
    state.userSendCode.loading = true;
  },
  [userSendCode.fulfilled]: (state, action) => {
    state.userSendCode.loading = false;
    state.userSendCode.data = action.payload;
    state.userSendCode.error = null;
  },
  [userSendCode.rejected]: (state, action) => {
    state.userSendCode.loading = false;
    state.userSendCode.error = action.payload;
  },
};
